<div
  *ngIf="isAnyInfoShown"
  class="mx-2 md:mx-4 px-1 md:px-2 py-0.5 md:py-1 bg-gray-800 rounded flex flex-row"
>
  <ng-container
    *ngIf="enabledLiquiditySourcesCount !== totalLiquiditySourcesCount"
  >
    <a
      routerLink="settings"
      [floatUi]="liquiditySourcesTooltip"
      class="flex items-start cursor-pointer"
    >
      <ng-icon name="hero-funnel-mini"></ng-icon>
      <div class="ml-1 flex flex-row items-start">
        <span class="text-xs font-semibold">{{
          enabledLiquiditySourcesCount
        }}</span>
        <span class="text-xs text-gray-500 dark:text-gray-400"
          >/{{ totalLiquiditySourcesCount }}</span
        >
      </div>
    </a>
    <div class="-my-0.5 md:-my-1 mx-1 md:mx-2 w-0.5 bg-gray-900"></div>
  </ng-container>
  <ng-container *ngIf="activeChainSettingsState">
    <a
      [floatUi]="maxSlippageString"
      (click)="onOpenSettingsModalClick()"
      [class.cursor-pointer]="editable"
      class="flex items-start"
    >
      <ng-icon name="hero-arrow-trending-down-mini"></ng-icon>
      <div class="ml-1 flex flex-row items-start">
        <span class="text-xs font-semibold">{{
          activeChainSettingsState.maxSlippage | percent: '0.2-2'
        }}</span>
      </div>
    </a>
    <div class="-my-0.5 md:-my-1 mx-1 md:mx-2 w-0.5 bg-gray-900"></div>
    <a
      [floatUi]="maxPriceImpactString"
      (click)="onOpenSettingsModalClick()"
      [class.cursor-pointer]="editable"
      class="flex items-start"
    >
      <ng-icon name="hero-shield-exclamation-mini"></ng-icon>
      <div class="ml-1 flex flex-row items-start">
        <span class="text-xs font-semibold">{{
          activeChainSettingsState.maxPriceImpact | percent: '0.2-2'
        }}</span>
      </div>
    </a>
    <div class="-my-0.5 md:-my-1 mx-1 md:mx-2 w-0.5 bg-gray-900"></div>
    <a
      [floatUi]="minExpirySecString"
      (click)="onOpenSettingsModalClick()"
      [class.cursor-pointer]="editable"
      class="flex items-start"
    >
      <ng-icon name="hero-clock-mini"></ng-icon>
      <div class="ml-1 flex flex-row items-start">
        <span class="text-xs font-semibold">{{
          activeChainSettingsState.minExpirySec
        }}</span>
      </div>
    </a>
  </ng-container>
</div>
